import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import "./../index";

import BuyerPOView from "../../BuyerPO/Components/BuyerPOView";

import { getBuyerPOByBuyerPOId } from "../../../services/api/buyerPO"
import { getProformaInvoiceByBuyerPOId } from "../../../services/api/proformaInvoice"

import { raiseToast } from "../../../services/redux/reducers/toast/toast";


const NewBuyerPOModalData = (props) => {
    const { buyerPOId, buyerPOItems, selectedReq, materialDetails } = props

    const [isLoading, setIsLoading] = useState(false)

    const [buyerPO, setBuyerPO] = useState(props.buyerPO)
    const [buyerReq, setBuyerReq] = useState(selectedReq)
    const [buyerQuote, setBuyerQuote] = useState(props.buyerQuotes)
    const [proformaInvoice, setProformaInvoice] = useState({})
    const [poSchedule, setPOSchedule] = useState([])
    const [poScheduleItems, setPOScheduleItems] = useState([])
    const [poPunch, setPOPunch] = useState([])
    const [poPunchItems, setPOPunchItems] = useState([])

    const [approvalInstances, setApprovalInstances] = useState(props.approvalInstances)
    
    const [pmCompanyBillAddrDetails, setPMCompanyBillAddrDetails] = useState({})
    const [buyerBillAddrDetails, setBuyerBillAddrDetails] = useState({})

    const [documentHTML, setDocumentHTML] = useState('')
    const [buyerPOPdfURL, setBuyerPOPDFURL] = useState('')
    
    const dispatch = useDispatch()

    useEffect(()=>{
        getBuyerPO()
    }, [])

    const getBuyerPO = async () => {
        setIsLoading(true)
        const response = await getBuyerPOByBuyerPOId(buyerPOId)

        if(response.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({severity:'error', summary: 'Buyer PO', detail: response.data.error, life: 3000}))
        }
        const relatedBuyerPO = response?.data.buyerPO

        let buyerPOItems = response?.data.buyerPOItems
        let updatedPOPunch = response?.data.poPunch
        let updatedPOScheduleItems = response?.data.poScheduleItem
        let updatedPOPunchItems = response?.data.poPunchItem
        let updatedPOSchedule = response?.data.poSchedule
        let equalQuantityScheduled = true
        buyerPOItems?.map(eachBuyerPOItem => {
            let totalScheduledQty = 0
            updatedPOScheduleItems?.map(eachPOScheduleItem => {
                if (eachPOScheduleItem.buyerReqItemId === eachBuyerPOItem.buyerReqItemId) {
                    totalScheduledQty += eachPOScheduleItem.scheduledQty
                }
            })
            if (totalScheduledQty !== eachBuyerPOItem?.bPOQty) {
                equalQuantityScheduled = false
            }
        })
        let updatedBuyerPO
        if (relatedBuyerPO?.poSource === "Normal") {
            updatedBuyerPO = { ...relatedBuyerPO, isPunchDone: true, isNormalPunchDone: true }
        } else if (relatedBuyerPO?.poSource === "Via Mail") {
            updatedBuyerPO = { ...relatedBuyerPO, isNormalPunchDone: false, isPunchDone: true }
        } else {
            updatedBuyerPO = { ...relatedBuyerPO, isPunchDone: false }
        }
        
        const proformaInvoiceRes = await getProformaInvoiceByBuyerPOId(buyerPOId)
        if(proformaInvoiceRes.failure){
            dispatch(raiseToast({severity:'error', summary: 'Proforma Invoice', detail: proformaInvoiceRes.data.error, life: 3000}))
        }else {
            setProformaInvoice(proformaInvoiceRes?.data)
        }

        setBuyerPO(relatedBuyerPO)
        setPOPunch(updatedPOPunch)
        setPOPunchItems(updatedPOPunchItems)
        setPOSchedule(updatedPOSchedule)
        setPOScheduleItems(updatedPOScheduleItems)
        // setShowSubmitPO(equalQuantityScheduled)

        setPMCompanyBillAddrDetails(response?.data?.pmCompanyBillAddrDetails)
        setBuyerBillAddrDetails(response?.data?.buyerBillAddrDetails)
        setDocumentHTML(response?.data?.documentHTML)
        setBuyerPOPDFURL(response?.data?.buyerPOPDFURL)

        setIsLoading(false)
    }

    return (
        <>
           <BuyerPOView
                displayTable={true} 
                buyerPOId={buyerPOId}
                buyerPO={buyerPO}
                buyerPOItems={buyerPOItems}
                poPunch={poPunch}
                buyerReq={buyerReq}
                buyerQuote={buyerQuote}
                buyerBillAddrDetails={buyerBillAddrDetails}
                materialDetails={materialDetails}
                documentHTML={documentHTML}
                buyerPOPdfURL={buyerPOPdfURL}
                setBuyerPOPDFURL={setBuyerPOPDFURL}
                getBuyerPO={getBuyerPO}
                approvalInstances={approvalInstances}
                setApprovalInstances={setApprovalInstances}
                proformaInvoice={proformaInvoice}
                setProformaInvoice={setProformaInvoice}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
            />
        </>
    )
}

export default NewBuyerPOModalData;